/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IMessageListItemPresenterSchema } from '../../entities/message/MessageListItemPresenterSchema';
import { IUserListItemPresenterSchema } from '../../entities/user/UserListItemPresenterSchema';

export type TMessagesOfferModel = IModel<IMessagesOfferRequest, TMessagesOfferResponse>;

export interface IMessagesOfferRequest {
  /** Токен капчи(для проверки валидности, только desktop) **/
  captchaToken?: string | null;
  /** Email пользователя **/
  email?: string | null;
  /** Идентификатор объявления **/
  offerId: number;
  /** Телефон пользователя **/
  phone?: string | null;
  /** Текст сообщения **/
  text: string;
}

export type TMessagesOfferResponse = IMessagesOfferResponse200 | IMessagesOfferResponse400;

export interface IMessagesOfferResponse200 extends IModelResponse<IMessagesOfferResponse> {
  statusCode: 200;
}

export interface IMessagesOfferResponse400 extends IModelResponse<IMessagesOfferResponseError> {
  statusCode: 400;
}

export interface IMessagesOfferResponse {
  /** Чат архивирован **/
  archived?: boolean | null;
  /** Чат архивирован мастер агентом **/
  archivedByMasterAgent?: boolean | null;
  /** Чат заблокирован **/
  blocked?: boolean | null;
  /** Чат заблокирован мастер агентом **/
  blockedByMasterAgent?: boolean | null;
  /** Пользователи, заблокировавшие чат **/
  blockedByUserIds?: number[] | null;
  /** Идентификатор чата **/
  chatId?: string | null;
  /** Таймстемп создания чата **/
  created?: number | null;
  /** Таймстемп создания чата(c точностью до ms) **/
  createdMs?: number | null;
  /** Дополнительная информация о чате **/
  data?: any | null;
  /** Чат удален **/
  deleted?: boolean | null;
  /** Последнее сообщение **/
  message?: IMessageListItemPresenterSchema | null;
  /** Заголовок чата **/
  title?: string | null;
  /** Тип чата **/
  type?: EType | null;
  /** Кол-во непрочитанных сообщений **/
  unread?: number | null;
  /** Таймстемп обновления чата **/
  updated?: number | null;
  /** Таймстемп обновления чата(с точностью до ms) **/
  updatedMs?: number | null;
  /** undefined **/
  users?: IUserListItemPresenterSchema[] | null;
  /** Чат между модератором и пользователем **/
  withModerator?: boolean | null;
}

export interface IMessagesOfferResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IMessagesOfferResponse | IMessagesOfferResponseError;

export enum EType {
  /** Чат между двумя пользователями по карточке агента **/
  Agent = 'agent',
  /** Чат между двумя пользователями по объявлению **/
  Offer = 'offer',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IMessagesOfferResponse): TResponse200;
  400(response: IMessagesOfferResponseError): TResponse400;
}
